import { useState } from "react";
import { ProfileDraftComparison } from "@/components/athlete/ProfileDraftComparison";

/** Read-only fixture preview of the two athlete review cases. Uses sample data only; nothing is saved. */
const LIVE = {
  name: "Sample Athlete", sport: "Football", tagline: "Disciplined enough to show up when it's hard",
  bio: "Original live bio.", hometown: "Sample Town", why_i_play: null, gallery_paths: [], instagram_url: "https://instagram.com/sample",
};
const PROPOSED = {
  ...LIVE, bio: "Refined bio prepared by SIIS.", why_i_play: "For the girls who come next.",
  gallery_paths: ["a.jpg", "b.jpg", "c.jpg"],
};

const AdminDraftReviewPreview = () => {
  const [mode, setMode] = useState<"live" | "draft" | "stale">("draft");
  return (
    <div className="max-w-3xl mx-auto p-4 space-y-4">
      <div>
        <h1 className="font-display text-2xl">Athlete review cases (sample data)</h1>
        <p className="text-sm text-muted-foreground">Preview only. Not connected to any athlete record.</p>
      </div>
      <div role="tablist" className="flex flex-wrap gap-2">
        {([["live", "Approve current live profile"], ["draft", "Review proposed changes"], ["stale", "Live changed since draft"]] as const).map(([k, l]) => (
          <button key={k} role="tab" aria-selected={mode === k} onClick={() => setMode(k)}
            className={`rounded-full px-4 min-h-[40px] text-sm font-semibold border ${mode === k ? "bg-primary text-primary-foreground border-primary" : "border-border"}`}>
            {l}
          </button>
        ))}
      </div>
      {mode === "live" ? (
        <section className="rounded-2xl border border-border bg-card p-5 space-y-2">
          <p className="text-xs font-semibold uppercase tracking-wider text-primary">Approve current live profile</p>
          <h2 className="font-display text-xl">Happy with what's already public?</h2>
          <p className="text-sm text-muted-foreground">Approving records this exact live version. Nothing on your profile changes, and it stays public.</p>
        </section>
      ) : (
        <ProfileDraftComparison live={LIVE} proposed={PROPOSED} liveChangedSinceDraft={mode === "stale"} />
      )}
    </div>
  );
};

export default AdminDraftReviewPreview;
